// extracted by mini-css-extract-plugin
module.exports = {"video":"rich-text-renderer_video__y2W6P","rtParagraph":"rich-text-renderer_rtParagraph__bBnfs"};